import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import DibsItForm from './containers/DibsItForm/DibsItForm';
import Layout from './containers/Layout/Layout';
// import About from './components/UI/About/About';
import TrdHowItWorks from './components/UI/HowItWorks/TrdHowItWorks/TrdHowItWorks'
import TrdAdminFocus from './components/UI/TrdAdminFocus/TrdAdminFocus';
import DibsItLanding from './containers/DibsItLanding/DibsItLanding';
import AdminConsole from './containers/AdminConsole/AdminConsole';
import AddPinTrd from './components/UI/AddPinTrd/AddPinTrd';
import TrdEdit from './components/UI/TrdAdminFocus/TrdEdit/TrdEdit';
import ArchiveConsole from './containers/ArchiveConsole/ArchiveConsole';
import HowItWorksPage from './components/UI/HowItWorks/TrdHowItWorks/HowItWorksPage/HowItWorksPage';
import Auth from './containers/Auth/Auth';
import Logout from './containers/Auth/Logout/Logout';

import * as actions from './store/actions/index';

//import './App.css';

class App extends Component {

  componentDidMount () {
    this.props.onTryAutoSignup()
  }

  render() {
    return (
      <div>
          <Layout>
            <Switch>

              {/* <Route path="/about" component={About} exact/> */}
              <Route path="/signin" component={Auth} exact />
              <Route path="/logout" component={Logout} exact />
              <Route path="/admin" component={AdminConsole} exact />
              <Route path="/addPinTrd" component={AddPinTrd} exact />
              <Route path="/trd/:id" component={DibsItForm} exact/>
              <Route path="/admin/focus/trd/:id" component={TrdAdminFocus} exact /> 
              <Route path="/admin/focus/trd/edit/:id" component={TrdEdit} exact/>
              <Route path="/admin/archive/trd" component={ArchiveConsole} exact />
              <Route path="/trd/howitworks" component={TrdHowItWorks} exact/>
              <Route path="/help/:val" component={HowItWorksPage} exact/>
              <Route path="/" component={DibsItLanding} />
              <Route render={() => <div>Not Found</div>} />
            </Switch>
          </Layout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  }
}



export default withRouter(connect(null, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/App.js